import { oklch, rgb, formatHex } from 'culori';
import { Color } from 'three';

const themes = {
   
    dark: {
      "color-scheme": "dark",
      "primary": "oklch(65.69% 0.196 275.75)",
      "secondary": "oklch(74.8% 0.26 342.55)",
      //"accent": "oklch(74.51% 0.167 183.61)",
      "neutral": "#2a323c",
      "neutral-content": "#A6ADBB",
     // "base-100": "#1d232a",
     // "base-200": "#191e24",
      //"base-300": "#15191e",
      //"base-content": "#A6ADBB",
      "base-200": "#3b4754",
          //"base-content": "#f0f1f4",
          "accent": "#A8CB9F",
          "base-content": "#e2e4e9",
          "base-300": "#191e24",
          "base-100": "#2a323c",

    },
    light: {
      "color-scheme": "light",
      "primary": "oklch(49.12% 0.3096 275.75)",
      "secondary": "oklch(69.71% 0.329 342.55)",
      "secondary-content": "oklch(98.71% 0.0106 342.55)",
      //"accent": "oklch(76.76% 0.184 183.61)",
      "neutral": "#2B3440",
      "neutral-content": "#D7DDE4",
      "base-100": "oklch(100% 0 0)",
      "base-200": "#F2F2F2",
      "base-300": "#E5E6E6",
      "base-content": "#1f2937",
      "accent": "#A8CB9F"
    },
  }
  
  export const getColorString = (theme: string, colorName: string): string => {
    return themes[theme][colorName];
  };
  
  export const getColorHex = (theme: string, colorName: string): string => {
    const color = getColorString(theme, colorName);
    
    // Check if the color is already in hex format
    if (/^#[0-9A-Fa-f]{6}$/.test(color)) {
      return color;
    }
    
    // Check if the color is in rgb or rgba format
    const rgbMatch = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    const rgbaMatch = color.match(/^rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)$/);
    
    if (rgbMatch || rgbaMatch) {
      const rgb = rgbMatch || rgbaMatch;
      const r = parseInt(rgb[1], 10);
      const g = parseInt(rgb[2], 10);
      const b = parseInt(rgb[3], 10);
      return formatHex({ mode: 'rgb', r: r / 255, g: g / 255, b: b / 255 });
    }
    
    // Check if the color is in OKLCH format
    const oklchMatch = color.match(/^oklch\((\d+(?:\.\d+)?)%\s+(\d+(?:\.\d+)?)\s+(\d+(?:\.\d+)?)\)$/);
    if (oklchMatch) {
      const l = parseFloat(oklchMatch[1]) / 100;
      const c = parseFloat(oklchMatch[2]);
      const h = parseFloat(oklchMatch[3]);
      const rgbColor = rgb(oklch({ mode: 'oklch', l, c, h }));
      return formatHex(rgbColor);
    }
    
    // If it's not a recognized format, return the original string
    return color;
  };

  export const getThreeJsColor = (theme: string, colorName: string): Color => {
    const hexColor = getColorHex(theme, colorName);
    
    // If the color is already in hex format or was successfully converted to hex
    if (hexColor.startsWith('#')) {
      return new Color(hexColor);
    }
    
    // For non-convertible formats, we'll use a default color (white) and log a warning
    console.warn(`Unable to convert color "${hexColor}" to Three.js Color. Using white as fallback.`);
    return new Color(0xffffff);
  };